var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function subscribeAll(conn, store, queries) {
    queries.forEach(q => {
        const id = store.getQueryID(q);
        const parsedQuery = JSON.parse(q);
        if (Object.keys(parsedQuery.params).length > 0 && id) {
            conn.send(parsedQuery);
        }
    });
}
// after socket is connected connectWithSubscriptions must send only queries which are added before jwt token is downloaded
// and socket start to connecting, not to send queries which are added while we connected(this query will be handled by applyQueries)
export function connectWithSubscriptions(conn, store, url) {
    return __awaiter(this, void 0, void 0, function* () {
        if (store.getAllQueries().length > 0) {
            const currentQueries = store.getAllQueries();
            const x = yield conn.connect(url);
            subscribeAll(conn, store, currentQueries);
            return x;
        }
        return conn.isConnected();
    });
}
//# sourceMappingURL=connectWithSubscriptions.js.map